var map = {
	"./arrow_back.png": 5481,
	"./arrow_forward.png": 6091,
	"./enchufe.png": 70,
	"./grid.png": 4286,
	"./logoPlexigridBlack.png": 1040,
	"./logoPlexigridYellow.png": 5850,
	"./logoUserYellow.png": 6616,
	"./plant-1.png": 6012,
	"./plant-green.png": 1220,
	"./queries": 8153,
	"./queries.js": 8153,
	"./rayo.png": 1616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;